import { FormattedMessage } from 'react-intl'
import Info from 'components/shared/Info'
import Box from 'components/shared/Box'
import { useAppSelector } from 'store/hooks'

export const RequirementsWarnings = () => {
    const cartTickets = useAppSelector((state) => state.cart.items.tickets)

    const hasNoTickets = !cartTickets.length
    const hasNoMatchingTickets = cartTickets.some(
        (ticket) => ticket.detail.zone === 'jamango'
    )

    return !hasNoTickets && !hasNoMatchingTickets ? null : (
        <Box mb={[16, 24]} isFullWidth>
            <Info color="info">
                {hasNoTickets ? (
                    <FormattedMessage
                        id="upsells.wellness.no_tickets_warning"
                        defaultMessage="Z oferty Wellness & SPA mogą korzystać osoby, które ukończyły 16 lat i mają bilet wstępu do strefy Relax."
                    />
                ) : (
                    hasNoMatchingTickets && (
                        <FormattedMessage
                            id="upsells.wellness.no_matching_tickets_warning"
                            defaultMessage="Niektóre bilety w Twoim koszyku nie zawierają wstępu do strefy Relax, więc nie uprawniają do skorzystania z oferty Wellness & SPA."
                        />
                    )
                )}
            </Info>
        </Box>
    )
}
